import React from 'react';
import Link from 'gatsby-link';
import get from 'lodash/get';
import Helmet from 'react-helmet';
import styled from "styled-components";
import mediumZoom from 'medium-zoom'
import anime from 'animejs'

import Footer from '../components/footer';

class Template extends React.Component {
  constructor(props, context){
    super(props, context);
    this.state = {images: []};
    this.setCat = this.setCat.bind(this);
}
setCat(cat) {
  this.setState(prevState => ({
    category: cat
  }));
}
  componentDidMount(){

    let regex = /\[([^]+)\]/g;
    var reqThumb = require.context("../gallery/thumbs", false, /.*\.(jpg|gif|png)$/);
    var req = require.context("../gallery", false, /.*\.(jpg|gif|png)$/);
    let list = [];
    req.keys().forEach(function(key){
      list.push({category: /\[([^]+)\]/g.exec(reqThumb(key)) ? /\[([^]+)\]/g.exec(reqThumb(key))[1] : "Photography", thumb: reqThumb(key), img: req(key) });
    });
    console.log(list);
    this.setState({ images: list, category: "All" });
    mediumZoom('[data-action="zoom"]');


  }
    componentDidUpdate() {
      mediumZoom('[data-action="zoom"]');
      var playPause = anime({
        targets: '.gallery-img',
        opacity: [0,1],
        scale: [1.01, 1],
        translateY: [5, 1],
        delay: function(el, i, l) { return i * 10; },
        direction: 'alternate',
        loop: false,
        autoplay: true
      });
    }

  render() {
    let categories = [
      {cat: "All", label: "All"},
      {cat: "Photography", label: "Photography"},
      {cat: "UI", label: "UI"},
      {cat: "Animation", label: "Animation"},
      // {cat: "Illustration", label: "Illustration"}
    ]
    return (
      <div>
        <Helmet title={get(this, 'props.data.site.siteMetadata.title')}/>
      <div style={{marginTop: "-1em", backgroundColor: "#f8f8f9"}}>
      <div className="project-width rw-pad">
        <div className="category-holder">
          <div className="categoryLabel">Sort:</div>
          { categories.map((c, index) => {
            return( <div key={index} className={"category " + ((c.cat == this.state.category) ? "active" : "")  } onClick={(e) => this.setCat(c.cat, e)}>{c.label}</div> )
          })}
        </div>
    </div>
  </div>
      <div className="project-width rw-pad">
        <div  style={{marginTop: "1.5em"}} className="gallery">
        { this.state.images.filter( i => (this.state.category == "All") ? (true) : (i.category == this.state.category))
          .map((img, index) => {
          return( <img key={index} data-action="zoom" className="gallery-img" src={img.thumb} data-zoom-target={img.img} /> )
        })}
      </div>
        </div>
        <Footer />
    </div>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template



// WEBPACK FOOTER //
// ./src/pages/gallery.js